import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useTheme } from "@mui/material";
import { PlainText, Title4, Title5} from "./Typography";
import { ButtonBase } from "./Button";


export function DialogWindow({isOpen,onClose,dialogTitle,dialogText,actions}) {
    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle><Title5 title={dialogTitle}/></DialogTitle>
            <DialogContent>
                <DialogContentText color="textPrimary">
                    <Title5 title={dialogText}/>
                </DialogContentText>
            </DialogContent>
        {actions}
        </Dialog>
    )
}